module.exports = __webpack_public_path__ + "static/img/lxh.c8561c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/doctor/lxh.jpg
// module id = HLzi
// module chunks = 1